import Vue from 'vue';
import { isNull } from 'lodash-es';

export default class ContentOwnershipValidatorHelper {
  static valid (contentOwnership, enterpriseDeveloper) {
    if (contentOwnership) {
      if (Vue.prototype.$permissions['enterprise-developer']) {
        return (
          ContentOwnershipValidatorHelper.basicValidity(contentOwnership) &&
          ContentOwnershipValidatorHelper.playerValidity(contentOwnership)
        );
      } else {
        return (
          ContentOwnershipValidatorHelper.basicValidity(contentOwnership) &&
          ContentOwnershipValidatorHelper.playerValidity(contentOwnership) &&
          ContentOwnershipValidatorHelper.priceValidity(contentOwnership) &&
          ContentOwnershipValidatorHelper.discoverValidity(contentOwnership) &&
          ContentOwnershipValidatorHelper.EULAValidity(contentOwnership)
        );
      }
    }
  }

  static basicValidity (contentOwnership) {
    const {
      title,
      description,
      shortDescription,
      developers,
      headsetHtcVive,
      headsetOculusRift,
      headsetWindowsMr,
      headsetValveIndex,
      experienceType,
      difficulty,
      imageUrl,
      videoMp4Url,
      gameplayVideoMp4Url,
      developerSupportEmail,
      systemRequirements,
      _imageBlob,
      _videoBlob,
      genres,
    } = contentOwnership;
    const emailRE = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return Boolean(
      title &&
      description &&
      shortDescription &&
      developers &&
      (headsetHtcVive || headsetOculusRift || headsetWindowsMr || headsetValveIndex) &&
      experienceType &&
      difficulty &&
      developerSupportEmail && Boolean(developerSupportEmail.match(emailRE)) &&
      systemRequirements &&
      genres?.length > 0 && genres?.length <= 5 &&
      (imageUrl || _imageBlob) &&
      (videoMp4Url || gameplayVideoMp4Url || _videoBlob),
    );
  }

  static discoverValidity (contentOwnership) {
    return !isNull(contentOwnership.ageRating);
  }

  static playerValidity (contentOwnership) {
    if (Vue.prototype.$permissions['enterprise-developer']) return true;

    if (contentOwnership.multiplayer) {
      if (
        contentOwnership.maxPlayers === null ||
        contentOwnership.maxPlayers === ''
      ) {
        return false;
      }
      if (
        contentOwnership.minPlayers === null ||
        contentOwnership.minPlayers === '' ||
        parseInt(contentOwnership.minPlayers) >
          parseInt(contentOwnership.maxPlayers) ||
        parseInt(contentOwnership.minPlayers) < 1 ||
        parseInt(contentOwnership.maxPlayers) < 1
      ) {
        return false;
      }
      return true;
    }
    return contentOwnership.singleplayer;
  }

  static priceValidity (contentOwnership) {
    if (Vue.prototype.$permissions['enterprise-developer']) return true;
    if (typeof contentOwnership.basePriceMinute !== 'number') {
      return false;
    }

    if (
      contentOwnership.basePriceMinute < 0 ||
      contentOwnership.basePriceMinute > 99
    ) {
      return false;
    }

    if (!contentOwnership.disablePriceMonth) {
      if (contentOwnership.basePriceMonth === 'unset') return false;
      if (typeof contentOwnership.basePriceMinute !== 'number') {
        return false;
      }
      if (typeof contentOwnership.basePriceMonth === 'number') {
        if (contentOwnership.basePriceMonth < contentOwnership.basePriceMinute) {
          return false;
        }
      }
    }

    if (!contentOwnership.disablePriceYear) {
      if (contentOwnership.basePriceYear === 'unset') return false;
      if (typeof contentOwnership.basePriceYear === 'number') {
        if (contentOwnership.basePriceYear < contentOwnership.basePriceMinute) {
          return false;
        }
        if (
          typeof contentOwnership.basePriceMonth === 'number' &&
          contentOwnership.basePriceYear < contentOwnership.basePriceMonth
        ) {
          return false;
        }
      }
    }

    if (
      contentOwnership.basePricePlay === 'unset' ||
      contentOwnership.basePricePlay < 0 ||
      contentOwnership.basePricePlay > 2500
    ) {
      return false;
    }

    if (
      contentOwnership.upcomingPrices &&
      contentOwnership.upcomingPrices.length > 0
    ) {
      const foundInvalidRegionalPrice = !!contentOwnership.upcomingPrices.find(
        upcomingPrice => {
          return (
            upcomingPrice.priceMinute < 0 ||
            upcomingPrice.priceMinute > 99 ||
            (upcomingPrice.basePricePlay < 0 ||
              upcomingPrice.basePricePlay > 2500)
          );
        },
      );
      if (foundInvalidRegionalPrice) return false;

      return (
        contentOwnership.upcomingPrices.filter(price => !!price.distribute)
          .length > 0
      );
    }

    return true;
  }

  static CDSValidity (contentOwnership) {
    return (
      contentOwnership.cds && contentOwnership.approvalStatus === 'approved'
    );
  }

  static CDSUploadValidity (contentOwnership) {
    return (
      contentOwnership.approvalStatus === 'approved' ||
      contentOwnership.approvalStatus === 'pending'
    );
  }

  static EULAValidity (contentOwnership) {
    if (Vue.prototype.$permissions['enterprise-developer']) return true;
    if (contentOwnership.status !== 'active') {
      return !!contentOwnership.currentAgreement || (
        contentOwnership.upcomingAgreement &&
          contentOwnership.upcomingAgreement.content.length > 0
      );
    } else if (contentOwnership.upcomingAgreement) {
      return contentOwnership.upcomingAgreement.content.length > 0;
    }
    return !!contentOwnership.currentAgreement;
  }

  static keysValidity (contentOwnership) {
    if (contentOwnership.cds) return true;
    if (contentOwnership.status === 'active') {
      return contentOwnership.freeDownload
        ? contentOwnership.keysTotal > 99
        : true;
    } else {
      return contentOwnership.freeDownload
        ? contentOwnership.keysTotal > 99
        : contentOwnership.keysTotal > 4;
    }
  }
}
